import React, { useContext, useEffect, useRef, useState } from "react";
import "./Header.scss";
import { Trans, useTranslation } from "react-i18next";
import { BiLogOut } from "react-icons/bi";
import { getB2BTokens, logoutHandler } from "../../AuthService/userData";
import AuthContext from "../../Context/auth-context";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router";
import arabicLogo from "../../Assets/img/arabicLogo.svg";
import qrCode from "../../Assets/img/mobileAppQrCode.svg"
import SehaTech from "../../Assets/img/icons/SehaTech.png"
import arrowDown from "../../Assets/img/arrowDown.svg";
import defaultUser from "../../Assets/img/Default_User.svg";
import bell from "../../Assets/img/bell.svg";
import { getUserData } from "../../AuthService/userData";
import { getTokenByUser, onMessageListener } from "../../firebase";
import { MobileOutlined } from '@ant-design/icons';
import { Button, Modal } from "antd";
import { info } from "sass";
import CustomLine from "../../Components/Line/line";
import { MyContext } from "../../mycontext";
import ProviderNotifications from "../../Components/providerNotifications/ProviderNotifications";
import DocumentTitle from 'react-document-title';
const downloadMobileApp = () => {
  Modal.info({
    title: (
      <div>
        <h6>تحميل التطبيق</h6>
        <CustomLine />
      </div>
    ),
    content: (
      <div className="modalBody" style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "1rem",
        alignItems: "center",
        margin: 0,
        padding: 0,
        marginRight: "12%",
        marginTop: "1rem"
      }}>
        <h6>يمكنك الان تحميل تطبيق صحة تك لمزودي الخدمة عن طريق QR code في الأسفل</h6>
        <img src={qrCode} alt="qrCode" style={{ width: "100%" }}/>
      </div>
    ),
    icon: (<MobileOutlined style={{ color: "black" }}/>),
    onOk() {
      localStorage.setItem("isNotifiedApp", "true")
    },
  });
};

const Header = () => {
  const history = useHistory();
  const [socket] = useContext(MyContext);
  const [isTokenFound, setIsTokenFound] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [notificationCounter, setNotificationCounter] = useState(0);

  getTokenByUser(setIsTokenFound);

  onMessageListener().then((payload) => {
    console.log(payload);
  });

  const logout = () => {
    localStorage.removeItem("b2bTokens");
    window.location.href = "/login";
  };

  useEffect(() => {
    let isNotifiedApp = localStorage.getItem("isNotifiedApp");

    if (!isNotifiedApp) {
      downloadMobileApp()
    }
    
  }, [])
  
  function getNotDeliveredMessages(notificationsArray) {
    setNotificationCounter(counter => counter + notificationsArray.length);
    setNotifications(notifications => [...notificationsArray, ...notifications]);
  }
  useEffect(() => {
    socket?.on("notifications", getNotDeliveredMessages);
  }, [socket])

  useEffect(() => {
    return () => {
      socket?.off("notifications", getNotDeliveredMessages);
    }
  }, [])
  return (
    <>
      <DocumentTitle title={notificationCounter ? `Sehatech ( ${notificationCounter} )` : "Sehatech"}>
      <div className="header-container">
        <div className="header-right">
          <img src={SehaTech} alt="mainLogo" style={{ width: "40%" }} />
        </div>

        <div className="header-left">
          
          {/* <img src={bell} alt="notifications" onClick={() => { history.push("claim/notification") }} /> */}
          <ProviderNotifications notifications={notifications} notificationCounter={notificationCounter} setNotificationCounter={setNotificationCounter} />
          <div className="header-user">
            <img src={defaultUser} alt="defaultUser" />
            <div style={{ display: "flex", alignItems: "center" }}>
              <strong style={{ minWidth: `${Math.min(((getB2BTokens()[0].providerUserInfo.firstName?.length || 0) + (getB2BTokens()[0].providerUserInfo.lastName?.length || 0)) * 10, 330)}px`}} >
                {getB2BTokens() &&
                  getB2BTokens()[0].providerUserInfo.firstName +
                  " " +
                  getB2BTokens()[0].providerUserInfo.lastName}
              </strong>
            </div>
          </div>
          <Button style={{
            margin: "0 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "8px 8px",
            gap: "8px",
            padding: "4px",
            paddingRight: "8px",
          }} onClick={downloadMobileApp} type="default" icon={<MobileOutlined />}>تحميل التطبيق</Button>
          <div>
            <button className="button normal" onClick={() => logout()} style={{ lineHeight: 1, textWrap: 'nowrap' }}>
              Sign out
            </button>
          </div>
        </div>
      </div>
      </DocumentTitle>
    </>
  );
};

export default Header;
